import React, { useEffect, useState } from "react";
import Icon from "../../../../core-components/IconsSelector";
import * as S from "./InfoBar.styles";

interface IDP {
  dynamicPersuasion: Array<{
    text: string;
    tc: string;
    bgc: string;
    icon: string;
  }>;
}

const InfoBarUI: React.FC<IDP> = ({ dynamicPersuasion = [] }) => {
  var timerId;
  const [initialValue, setIndex] = useState(0);
  React.useEffect(() => {
    if (dynamicPersuasion?.length > 1 && !timerId) {
      timerId = setInterval(() => {
        if (initialValue < dynamicPersuasion.length) {
          setIndex((initialValue) => initialValue + 1);
        } else {
          setIndex(0);
        }
      }, 3000);
    }
    return () => clearInterval(timerId);
  });
  React.useEffect(() => {
    if (initialValue >= dynamicPersuasion.length) {
      setIndex(0);
    }
  }, [initialValue]);

  if (!dynamicPersuasion?.length) return null;
  const { text = "", icon = "", bgc = "", tc = "" } =
    dynamicPersuasion[initialValue] || {};
  return (
    <>
      <S.InfoCont bgc={bgc} tc={tc}>
        <img src={icon} style={{height: '21px'}}  />
        <p>{text}</p>
      </S.InfoCont>
    </>
  );
};

export default React.memo(InfoBarUI);
